/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-10 20:01:31
 */

import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo } from 'src/types/base';
import { defaultNullValue } from 'src/config';
export declare namespace StationListDOI {
    export interface RowDataI {
        name: string;
        secondary_enterprise_name: string;
        section: string;
        district_name: string;
        city_name: string;
        province_name: string;
        district_id: number;
        city_id: number;
        province_id: number;
        product_id: number;
        factorset: number;
        data_time: string;
        device_status: number;
        wxxxx: string;
        site_status: number;
        control_hierarchy: string;
        id: number;
        address: string;
        location_point: string
        mn: string
        type: number
        is_warning_notice: number
        water_level: number
        basin: string
        devops_personnel: string
        devops_mobile: string
        built_time:string
        reception_time:string
    }

    export interface DeviceRowDataI {
        name: string;
        secondary_enterprise_name: string;
        section: string;
        district_name: string;
        city_name: string;
        province_name: string;
        district_id: number;
        city_id: number;
        province_id: number;
        data_time: string;
        device_status: number;
        wxxxx: string;
        site_status: number;
        control_hierarchy: string;
        id: number;
        address: string;
        location_point: string
        mm: string
    }

    export interface QueryRowDataParamsI extends PageDo {
        device_name?: string;
        province_id?: number;
        city_id?: number;
        district_id?: number;
        type?: number;
        control_hierarchy?: number;
        communication_status?: number;
        site_status?: number;
    }

    export interface QueryDeviceRowDataParamsI extends PageDo {
        device_name?: string;
        mn?: string;
        province_id?: number;
        city_id?: number;
        district_id?: number;
        agreement_id?: number;
        product_id?: number;
        type?: number;
        basin?: string;
    }

    export interface QueryDetailResultI {}

    export interface OperateParamsI {}
}
export default class StationListApi {
    /**
     * 查询列表 待因子  用于站点检测列表
     * @param {StationListDOI.QueryRowDataParamsI} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchList(
        params: StationListDOI.QueryRowDataParamsI,
    ): Promise<ResultPageDo<StationListDOI.RowDataI[], { key: string; name: string; unit: string }[]>> {
        return Api.post('/monitor/point/device/data/condition', {
            province_id: defaultNullValue,
            city_id: defaultNullValue,
            district_id: defaultNullValue,
            type: defaultNullValue,
            control_hierarchy: defaultNullValue,
            communication_status: defaultNullValue,
            site_status: defaultNullValue,
            device_name: '',
            ...params,
        });
    }

    /**
     * 查询所有站点 
     */
    static async searchDeviceList(
        params: StationListDOI.QueryDeviceRowDataParamsI={},
    ): Promise<ResultPageDo<StationListDOI.RowDataI[]>> {
        return Api.post('/monitor/point/device/data/other', {
            province_id: defaultNullValue,
            city_id: defaultNullValue,
            district_id: defaultNullValue,
            type: defaultNullValue,
            agreement_id: defaultNullValue,
            product_id: defaultNullValue,
            page_index:1,
            page_size:10000000,
            basin: -2,
            mn: '',
            ...params,
        });
    }
}
